import { isUserTyping } from './user-typing';

export interface ShortcutCombo {
   key?: string;
   metaKey?: boolean;
   ctrlKey?: boolean;
   altKey?: boolean;
   shiftKey?: boolean;
}

function matchesShortcut(event: KeyboardEvent, combo: ShortcutCombo): boolean {
   if (!combo.key) return false;
   return (
      event.key.toLowerCase() === combo.key.toLowerCase() &&
      !!combo.metaKey === event.metaKey &&
      !!combo.ctrlKey === event.ctrlKey &&
      !!combo.altKey === event.altKey &&
      !!combo.shiftKey === event.shiftKey
   );
}

/**
 * Handles keyboard shortcuts for focusing or acting on an input element.
 * Supports multi-key combos and blocks when the user is typing.
 *
 * @param shortcutKeys Array of keys (e.g., ['/', 'k']) or a predicate function
 * @param inputElement The input element to act on
 * @param callback Optional callback to run when shortcut is triggered
 */
export function createShortcutHandler(
   shortcut: ShortcutCombo | ((event: KeyboardEvent) => boolean),
   inputElement: HTMLInputElement,
   callback: (input: HTMLInputElement, event: KeyboardEvent) => void
) {
   return (event: KeyboardEvent) => {
      if (isUserTyping()) {
         return;
      }

      const match =
         typeof shortcut === 'function' ? shortcut(event) : matchesShortcut(event, shortcut);

      if (!match) {
         return;
      }

      callback(inputElement, event);
   };
}
